module.exports = __webpack_public_path__ + "static/img/m_7.1b09a249.jpg";